import { FieldError } from 'react-hook-form';
import { IMappedAddressForm } from '../models/common/address-form';
import { getHyphenatedPhoneNumber } from './general';
import { IAddress } from '../models/address';

export const getTextFieldStatus = (error: FieldError | undefined) =>
  error ? 'error' : undefined;

export const getAddressFormValues = (
  address?: IAddress | null,
): IMappedAddressForm => {
  const cityState = address
    ? `${address?.postalAddress?.city}, ${address?.postalAddress?.stateProvince}`
    : '';
  return {
    firstName: address?.name?.firstName ?? '',
    lastName: address?.name?.lastName ?? '',
    addressLine1: address?.postalAddress?.addressLine1 ?? '',
    addressLine2: address?.postalAddress?.addressLine2 ?? '',
    zipCode: address?.postalAddress?.zipCode ?? '',
    cityState,
    primaryPhone: getHyphenatedPhoneNumber(address?.phones[0]?.number ?? ''),
  };
};
